<template>
  <div class="text-left p-10 w-full">
    <h5 class="mb-5">{{ data.nameId }} <span class="small">({{ data.nameEn }})</span></h5>

    <vs-list class="mt-5">
      <vs-list-item
        title="Top List"
        class="text-primary"
      >
        <p
          v-if="data.topLists.length < 3"
          class="text-primary cursor-pointer cursor-pointer"
          @click="addTopList"
        >Add item</p>
      </vs-list-item>

      <vs-list-item
        v-for="(item, index) in data.topLists"
        :key="index"
        :title="_.get(item, 'listing.name')"
        :subtitle="renderItemRenewal(item)"
      >

        <div class="flex">
          <vs-button
            color="dark"
            type="flat"
            icon="edit"
            @click="$emit('on-click-top-list', item)"
          />
          <vs-button
            color="danger"
            type="flat"
            icon="delete"
            @click="confirmDelete(index)"
          />
        </div>

        <template slot="avatar">
          <vs-avatar :src="_.get(item, 'listing.logoUrl')" />
        </template>
      </vs-list-item>

      <vs-list-item v-if="data.topLists.length < 1">No List Available</vs-list-item>

    </vs-list>

    <div class="w-full mt-10">
      <vs-button
        color="primary"
        icon="save"
        class="ml-auto"
        type="filled"
        @click="$emit('save-changes', data)"
      >Save</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      indexTopListForDeletion: null
    }
  },
  methods: {
    addTopList () {
      this.data.topLists.push({
        id: '',
        status: 'active',
        listing: {
          name: 'New list'
        },
        saler: {},
        dateRegister: null,
        dateRenewal: null,
        price: 0,
        priceRenewal: 0
      })
    },
    confirmDelete (index) {
      this.indexTopListForDeletion = index
      this.showConfirmDeletion(this.deleteItem)
    },
    deleteItem () {
      this.data.topLists.splice(this.indexTopListForDeletion, 1)
    },
    renderItemRenewal (item) {
      var text = ''

      text += this.formatDate(item.dateRegister)

      text += ` - ${this.formatDate(item.dateRenewal)} (Renewal ${this.formatIDR(item.priceRenewal)})`

      return text
    }
  }
}
</script>
